import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import AuthShell from "./AuthShell";
import { Field, Input } from "@/components/Field";

export default function Reset() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [f, setF] = useState({ token: params.get("token") || "", password: "" });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/reset-password", f); toast.success("OK"); nav("/login"); }
    catch (err) { toast.error(apiErr(err)); }
  };
  return (
    <AuthShell title={t("auth.forgot")}>
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <Field label="Token"><Input testid="reset-token" required value={f.token} onChange={(e) => setF({ ...f, token: e.target.value })} /></Field>
        <Field label={t("auth.password")}><Input testid="reset-password" type="password" required minLength={6} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} /></Field>
        <button className="btn-primary w-full" data-testid="reset-submit">{t("common.save")}</button>
      </form>
      <p className="text-sm text-muted-foreground mt-6 text-center"><Link to="/login" className="text-primary font-semibold">{t("nav.login")}</Link></p>
    </AuthShell>
  );
}
